import splitCamelCase from "webutils/filters/split-camel-case";
import startFrom from "webutils/filters/start-from";
import tel from "webutils/filters/tel";
import bytes from "webutils/filters/bytes";
import titleCase from "webutils/filters/title-case";
import ordinal from "webutils/filters/ordinal";
import safeHtml from "webutils/filters/safe-html";
import truncate from "webutils/filters/truncate";
import trusted from "webutils/filters/trusted";
import toDate from "webutils/filters/to-date";

export const dependencies = [];
export const filters = {
  splitCamelCase,
  startFrom,
  tel,
  bytes,
  titleCase,
  titlecase: titleCase,
  ordinal,
  safeHtml,
  truncate,
  trusted,
  toDate,
};

export default {
  dependencies,
  filters,
};
